import {
  serializeRegistrationBridgeMessage,
  type RegistrationBridgeMessage,
} from '@buxus/shared'

function getReactNativeBridge(): { postMessage: (message: string) => void } | null {
  const rn = (window as unknown as { ReactNativeWebView?: { postMessage?: (m: string) => void } })
    .ReactNativeWebView
  if (!rn || typeof rn.postMessage !== 'function') return null
  return { postMessage: rn.postMessage.bind(rn) }
}

/** True when the React Native shell can receive host bridge messages. */
export function hasNativeHostBridge(): boolean {
  return getReactNativeBridge() !== null
}

export function postNativeHostMessage(message: RegistrationBridgeMessage): void {
  const bridge = getReactNativeBridge()
  if (!bridge) return
  bridge.postMessage(serializeRegistrationBridgeMessage(message))
}
